import { format } from '@r1-frontend/ui-react/components/costs';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const rules = (cashback: string, isAbnProgramTermsEnabled?: boolean) => [
    {
        title: 'Зарегистрируйтесь в программе',
        desc: 'Для вступления в программу необходимо быть пользователем одной или нескольких услуг Дом.ру.',
        link: {
            text: 'Подробнее о программе',
            path: '/policy/loyaltyprogramm',
        },
    },
    {
        title: 'Получайте бонусы',
        desc: isAbnProgramTermsEnabled
            ? `Участник программы при единовременной оплате от ${format(3000)} получает кешбэк в виде бонусов в размере ${cashback} от абонентской платы.`
            : `Участник программы получает кешбэк в виде бонусов в размере ${cashback} от Абонентской платы, приобретенного товара или услуги.`,
    },
    {
        title: 'Управляйте бонусным счетом',
        desc: 'Получить информацию о состоянии бонусного счета можно в мобильном приложении «Мой Дом.ру» или на сайте Дом.ру.',
    },
];
